// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__13K8P","reviewAndSignButtonText":"styles_reviewAndSignButtonText__2fj4Y"};